import Gallery from "../blocks/gallery";

const TemplateDefault = {
  init() {
    console.log("TemplateDefault initialized");
    new Gallery(".gallery");
  },
};

export default TemplateDefault;
